<div class="flex justify-between px-6 py-5">
    <p class="text-[1.125rem] text-[#0A0A0A] font-bold">Edit pinned groups</p>
    <p
        class="text-[1.125rem] text-[#4F66FF] font-semibold cursor-pointer"
        (click)="onCancel(); notifyUpdatedPinnedGroups()">
        Done
    </p>
</div>

<div
    class="flex flex-col rounded-b-2xl border border-t-0 border-[#E7EAF0] max-h-[600px] overflow-y-auto popup-scrollable-main">
    @if (isInitialLoading()) {
        <app-group-skeleton></app-group-skeleton>
        <app-group-skeleton></app-group-skeleton>
        <app-group-skeleton></app-group-skeleton>
    } @else if (groupsData().length !== 0) {
        <div
            class="flex flex-col p-3 gap-3"
            infiniteScroll
            [infiniteScrollContainer]="'.popup-scrollable-main'"
            [fromRoot]="true"
            [infiniteScrollDistance]="1"
            (scrolled)="onScroll()">
            @for (item of groupsData(); track item.id) {
                <app-group [group]="item" [isEditPin]="true"></app-group>
            }
        </div>
    } @else {
        <div class="text-center text-[#717182] py-10">No joined groups found</div>
    }
</div>
